const trains = {
  train: "Zug", // translated
  trains: "Züge", // translated
  fairConditions: "Faire Konditionen", // translated
  to: "Zu", // translated
  earlier: "Früher", // translated
  later: "Später", // translated
  adults: "Erwachsene", // translated
  child: "Kind", // translated
  senior: "Senior", // translated
  seniors: "Senioren", // translated
  price: "Preis", // translated
  for: "für", // translated
  total: "Gesamt", // translated
  selected: "Ausgewählt", // translated
  prebook: "Vorreservieren", // translated
  book: "Buch", // translated
  payment: "Zahlung", // translated
  return: "Zurückkehren", // translated
  passengers: "Passagiere", // translated
  delivery: "Lieferung", // translated
  summary: "Zusammenfassung", // translated
  checkout: "Kasse", // translated
  trainToastCorrectFillForm: "Bitte füllen Sie alle Felder ordnungsgemäß aus.", // translated
  fareConditions: "Fahrpreisbedingungen", // translated
  travelInfo: "Reiseinformationen", // translated
  remarks: "Kundenbemerkungen", // translated
  noServices: "Keine Dienstleistungen", // translated
  timesAndSeats: "Zeiten und Sitzplätze", // translated
  mobileTicket: "Mobiles Ticket", // translated
  stationTicket: "Abholung am Bahnhof", // translated
  homeTicket: "Zuhause drucken", // translated
  countryCode: "Landesvorwahl", // translated
  chooseTicket: "Wählen Sie die Ticketzustellungsmethode", // translated
  ticketError: "Bitte wählen Sie ein Ticket für alle Ziele aus", // translated
  ticketDelivery: "Bitte wählen Sie eine Ticketversandmethode aus", // translated
  passengerDetails: "Passagiereinzelheiten", // translated
  waitWhileProcessingPayment: "Bitte warten Sie, während wir Ihre Zahlung verarbeiten. Aktualisieren oder schließen Sie die Seite nicht.", // translated
  reductionCardId: "Ermäßigungskarten-ID", // translated
  countryOfResidence: "Aufenthaltsland", // translated
  countryOfBirth: "Geburtsland", // translated
  documentCountry: "Dokumentland", // translated
  documentNumber: "Dokumentnummer", // translated
  expirationDate: "Verfallsdatum", // translated
  documentType: "Art des Dokuments", // translated
  travelerDocumentInfo: "Informationen zum Reisedokument", // translated
  youth: "Jugend", // translated
  youths: "Jugendliche", // translated
  departTimeEarlyFirst: "Abfahrtszeit (früheste zuerst)", // translated
};

export default trains;
